import React from 'react'
import { useInfo } from '../context/useInfo'
import ErrorBase from '../components/ErrorBase'

function NoPermissions() {
    return <ErrorBase
        errorCode={403}
        src="/images/monitor_red.png"
        errorDescription="You don't have enough permissions to access this page"
        className='text-red-600'
    />
}

export default NoPermissions